<template>
  <div>
    <JobPageDialogsItemHeader
      :user-account="dialog.freelancer"
      :last-offer="dialog.lastOffer"
      :dialog-type="dialog.dialogType"
      :yjob="yjob"
    />

    <JobPageDialogsItemMessage :dialog="dialog" />

    <JobPageDialogsItemFooter :dialog="dialog" :yjob="yjob" />
  </div>
</template>

<script>
import JobPageDialogsItemHeader from '@/components/JobPageDialogsItemHeader.vue'
import JobPageDialogsItemMessage from '@/components/JobPageDialogsItemMessage.vue'
import JobPageDialogsItemFooter from '@/components/JobPageDialogsItemFooter.vue'

/**
 * @emits dialog-unflagged
 * @emits dialog-flagged
 * @emits dialog-reopened
 * @emits dialog-closed
 * @emits removed-from-shortlist
 * @emits added-to-shortlist
 */
export default {
  components: {
    JobPageDialogsItemHeader,
    JobPageDialogsItemMessage,
    JobPageDialogsItemFooter,
  },
  props: {
    dialog: {
      type: Object,
      required: true,
    },
    yjob: {
      type: Object,
      required: true,
    },
    jobRankStarThreshold: {
      type: Number,
      default: () => 5,
    },
  },
}
</script>
